var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 10.5H18V7.5C18 5.85938 19.3125 4.5 21 4.5H21.375C21.9844 4.5 22.5 4.03125 22.5 3.375V1.125C22.5 0.515625 21.9844 0 21.375 0H21C16.8281 0 13.5 3.375 13.5 7.5V18.75C13.5 20.0156 14.4844 21 15.75 21H21.75C22.9688 21 24 20.0156 24 18.75V12.75C24 11.5312 22.9688 10.5 21.75 10.5ZM8.25 10.5H4.5V7.5C4.5 5.85938 5.8125 4.5 7.5 4.5H7.875C8.48438 4.5 9 4.03125 9 3.375V1.125C9 0.515625 8.48438 0 7.875 0H7.5C3.32812 0 0 3.375 0 7.5V18.75C0 20.0156 0.984375 21 2.25 21H8.25C9.46875 21 10.5 20.0156 10.5 18.75V12.75C10.5 11.5312 9.46875 10.5 8.25 10.5Z",
    className: "Svg-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quote-left.75c097a95c7dc57a5d8676dd6d8caa0a.svg";
export { ForwardRef as ReactComponent };